import axios from "./axiosInstance";
import {EditorState, Landmark, TrimPoint} from "../types/editor";
import {SocialClip} from "../types/clipTypes";

const baseUrl = process.env.REACT_APP_BASE_URL+"/editor";


export async function startEditing(clipId: string){
    const response = await axios.post(`${baseUrl}/${clipId}/startEditing`)
    return response.data;
}

export async function getBaseState(clipId: string){
    const response = await axios.get(`${baseUrl}/${clipId}/editingBaseState`)
    return response.data;
}

export async function saveTrimPoints(editSessionId: string, trimPoints: TrimPoint[]){
    await axios.put(`${baseUrl}/${editSessionId}/editTrim`, {trim_points: trimPoints})
}

export async function save(editSessionId: string): Promise<string>{
    const response = await axios.post(`${baseUrl}/${editSessionId}/saveState`)
    return response.data;
}

export async function editLandMark(editSessionId: string, landmark: Landmark, operation: string){
    const response = await axios.put(`${baseUrl}/${editSessionId}/editWindow`, {landmark, operation})
    return response.data
}

export async function downloadEdit(editSessionId: string, aspectRatio: string, resolution?: any, pix_fmt?: string){
    const response = await axios.post(`${baseUrl}/${editSessionId}/edit`, {aspect_ratio: aspectRatio, resolution: resolution, pix_fmt: pix_fmt})
    return response.data
}

export async function socialEdit(editStateId: string, aspectRatio: string, background = false): Promise<SocialClip>{
    const response = await axios.post(`${baseUrl}/${editStateId}/social_edit`, {aspect_ratio: aspectRatio, background})
    return response.data
}

export async function changeMode(editSessionId: string, mode: string): Promise<EditorState>{
    const response = await axios.post(`${baseUrl}/${editSessionId}/change_mode`, {mode})
    return response.data
}
export async function getEditStateById(editStateId: string): Promise<EditorState>{
    const response = await axios.get(`${baseUrl}/editState/${editStateId}`)
    return response.data;
}

